import { type SectionType } from '../sections/SectionTypeContext.tsx';
import { type IWidgetType } from './IWidgetType.ts';

/**
 * Determina se un widget è disponibile per un dato tipo di sezione, in base al
 * suo `supportedSectionTypes`. Speculare alla logica delle direttive
 * (`WidgetDirectivesInput`).
 *
 * - `supportedSectionTypes` assente ⇒ disponibile per tutte le sezioni
 * - `supportedSectionTypes` valorizzato ⇒ disponibile solo per i tipi elencati
 * - `supportedSectionTypes` array vuoto (`[]`) ⇒ non disponibile in nessuna sezione
 */
export function filterWidgetsBySectionType(
  widget: IWidgetType<any>,
  sectionType: SectionType,
): boolean {
  if (!widget.supportedSectionTypes) return true;
  return widget.supportedSectionTypes.includes(sectionType);
}
